export default "__VITE_ASSET__feeffece__"